import { ref } from '@zto/zpage'
import type { IApp } from '@zto/zpage'

import * as asyncUtil from './async'

let __favFoldersLoaded = false
let __favFolders = []

let __favLoaded = false
let __favItems = []

let __app: IApp | null = null

/**
 * 加载所有收藏夹
 */
export async function ensureFavFolders(app: IApp, force?: boolean) {
  if (__favFoldersLoaded && force !== true) return __favFolders

  __app = app

  await asyncUtil.blockExecute(_loadFavFolders)

  return [...__favFolders]
}

export async function ensureFavs(app: IApp, force?: boolean) {
  if (!app?.isPortal) return []
  if (__favLoaded && force !== true) return [...__favItems]

  __app = app

  await asyncUtil.blockExecute(_loadFavs)

  const userFavorite = app.stores.userStore?.data?.favorite
  if (userFavorite) {
    userFavorite.favs = __favItems
  }

  return [...__favItems]
}

async function _loadFavFolders() {
  if (!__app) throw Error('获取app实例失败')
  if (!__app.isPortal) return

  const res = await __app.request({
    api: 'workbench.pc.queryCollectionGroup'
  })

  __favFolders = res || []
  __favFoldersLoaded = true
}

async function _loadFavs() {
  if (!__app) throw Error('获取app实例失败')
  if (!__app.isPortal) return

  const res = await __app.request({
    api: 'workbench.pc.queryTileCollections'
  })

  __favItems = res || []
  __favLoaded = true
}

/**
 * 请求收藏项
 * @param app
 * @param pid
 * @returns
 */
export async function fetchFavItems(app: IApp, pid: number) {
  if (!app.isPortal) return []

  const res = await app.request({
    api: 'workbench.pc.queryCollectionByPid',
    // api: 'workbench.pc.queryAllCollection',
    params: { pid }
  })

  return res
}

/**
 * 移除收藏项
 * @param app
 * @param id
 */
export async function removeFavItem(app: IApp, id: number) {
  await app.request({
    api: 'workbench.pc.cancelCollection',
    params: { id }
  })

  await ensureFavs(app, true)
}

/**
 * 新增收藏项
 * @param app
 * @param pid
 * @param menu
 */
export async function addFavItem(app: IApp, pid: number, menu: any) {
  await app.request({
    api: 'workbench.pc.addCollection',
    params: {
      pid,
      type: 'PC_MENU',
      itemCode: menu.bizId,
      itemName: menu.title
    }
  })

  await ensureFavs(app, true)
}

/**
 * 新增子菜单
 * @param app
 * @param pid
 * @param folderName
 */
export async function addFavFolder(app: IApp, pid: number, folderName: string) {
  await app.request({
    api: 'workbench.pc.addCollection',
    params: { pid, type: 'PC_MENU_GROUP', folderName }
  })
}
